"use strict";
export const cartoHelpers = {
    fromApiToMapPoints,
    calcularDistancia,
};

function _fromApiToPointFeature(elemento) {

    const geoPoint = {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [
                parseFloat(elemento.coordenadas[1]),
                parseFloat(elemento.coordenadas[0])
            ]
        },
        "properties": {
            "id": elemento.id,
            "name": elemento.name,
            //"guardado": elemento.guardado,
            "parkings": elemento.parkings || [],
            "refugios": elemento.refugios || [],
            //"cerrado": elemento.cerrado,
            //"online": elemento.online,
            //"noguardado": elemento.noguardado,
            //"imagen" : elemento.imagen,
            "friendly": elemento.friendlyUrl
        }
    };
    return geoPoint
}

function _fromApiToCircuitFeature(elemento) {
    const geoPoint = {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [
                parseFloat(elemento.coordenadas[1]),
                parseFloat(elemento.coordenadas[0])
            ]
        },
        "properties": {
            "id": elemento.id,
            "name": elemento.name
        }
    };
    return geoPoint
}

function fromApiToMapPoints(elements, type) {
    const tipo = type || 'refugio'
    const featureCollection = {
        type: 'FeatureCollection',
        features: []
    };
    if(tipo == 'refugio')
        elements.forEach( item => {
            if(item.coordenadas[0] !== item.coordenadas[1])
                featureCollection.features.push(_fromApiToPointFeature(item))
        });
    else if(tipo == 'parking') {
        elements.forEach(item => {
           item.coordenadas = [item.latitude, item.longitude];
           featureCollection.features.push(_fromApiToCircuitFeature(item))
        });
    }else
        elements.forEach( item => {
            item.coordenadas = item.centerPoint.split(',')
            featureCollection.features.push(_fromApiToCircuitFeature(item))
        });
    return featureCollection;
}



function calcularDistancia(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radio de la tierra en Km
    const dLat = _toRad(lat2-lat1);
    const dLon = _toRad(lon2-lon1);
    const _lat1 = _toRad(lat1);
    const _lat2 = _toRad(lat2);

    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(_lat1) * Math.cos(_lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const d = R * c;
    return d;
}

function _toRad(value) {
    return value * Math.PI / 180;
}